/* eslint-disable array-callback-return */
import {useEffect, useState} from 'react';
import {TextField} from "@mui/material";
import { GENERATEID } from '../../../shared/utils/Utils'
import CONSTANTS from '../../../shared/utils/Constants';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FormControl from '@mui/material/FormControl';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MobileTimePicker from '@mui/lab/MobileTimePicker';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CustomButtonSecondary from '../../../shared/atomic_components/button/CustomButtonSecondary';
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Tooltip from '@mui/material/Tooltip';
import { Fields, Subsections } from '../../../services/models/objs/StorSection';
import 'dayjs/locale/it';


type SegnalazioneCreateSubsectionType = {
    segnalazioneChoiceLists : {[key : string] : any},
    notificationFunctions : any,
    setNewSegnalazione : any,
    fieldIsRequiredAndMissing : any,
    newStorHasFieldMissing : any,
    errorClickingNextSection : boolean,
    newSegnalazione : {[key : string] : any},
    storSectionName : string,
    storSubsectionStructure : Subsections
}

const SegnalazioneCreateSubsection =  ({segnalazioneChoiceLists,
                      notificationFunctions,
                      setNewSegnalazione,
                      fieldIsRequiredAndMissing,
                      newStorHasFieldMissing,
                      errorClickingNextSection,
                      newSegnalazione,
                      storSectionName,
                      storSubsectionStructure } : SegnalazioneCreateSubsectionType) => {

    const [subsectionElement, setSubsectionElement] = useState<{[key : string] : any}>({})
    const [subsectionElements, setSubsectionElements] = useState<any[]>([])
    const [clickedAddButton, setClickedAddButton] = useState(false)
    const [tooltipIdentificativo, setTooltipIdentificativo] = useState('Non Presente')
    const [noteRequired, setNoteRequired] = useState(checkId())
    const [noteArrayCheck, setNoteCheck] = useState<string[]>([])
    const maxDate = new Date();

    useEffect(() => {
        if (newSegnalazione[storSectionName] && newSegnalazione[storSectionName][storSubsectionStructure.id]) {
            setSubsectionElements(newSegnalazione[storSectionName][storSubsectionStructure.id])
        }
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // [] means run only ones

    function checkId(){
        if(newSegnalazione[storSectionName] && newSegnalazione['identitaSegnalante'] && newSegnalazione['identitaSegnalante']['vesteSegnalante'])
        {
            if(newSegnalazione['identitaSegnalante']['vesteSegnalante']['catTipologiaNegoziazioneId'] === 44 || newSegnalazione['identitaSegnalante']['vesteSegnalante']['catTipologiaStrumNegoziatoId'] === 22  
            || newSegnalazione['identitaSegnalante']['vesteSegnalante']['vesteSegnalanteId'] === 11){
                return true
            }
            else
                return false
        }
        else
            return false
    }

    function subsectionHandleChange(event : any, field : Fields) {
        if(field.name === 'codiceIdentificativo'){
            const tooltip = event ? (event.target ? (event.target.value && event.target.value.length > 0 ? '' : 'Non Presente') : '') : '';
            setTooltipIdentificativo(tooltip);
        }
        if (storSubsectionStructure.multipleValue) {
            addFieldToSubsectionElement(field, event.target.value)
        }
        else {
            addFieldToSegnalazione(field, event.target.value)
        }
    }

    function subsectionHandleChangeChoice(event : any, field : Fields){
        let id = ''
        segnalazioneChoiceLists[field?.choiceListName || ''].forEach((list : any) => {
            if(event.target.value === list.name){
                id = list.id
            }
        });
        let tempArray = noteArrayCheck
        if(((field?.name === "catTipologiaStrumNegoziato" && id == '22') || (field?.name === "vesteSegnalante" && id == '11') 
        || (field?.name === "catTipologiaNegoziazione" && id == '44')) && field.required){
            tempArray.push(id)
            setNoteRequired(true)
        }
        else if(field?.name === "catTipologiaStrumNegoziato" || field?.name === "vesteSegnalante" || field?.name === "catTipologiaNegoziazione"){
            let catId = ""
            if(tempArray.length !== 0){
                switch(field.name) { 
                    case "catTipologiaStrumNegoziato": { 
                       catId = "22"
                       break; 
                    } 
                    case "vesteSegnalante": { 
                       catId = "11"
                       break; 
                    } 
                    case "catTipologiaNegoziazione": { 
                       catId = "44"
                       break; 
                    } 
                 } 
                tempArray.forEach(check => {
                    if(check == catId){
                        const index = tempArray.indexOf(check);
                        tempArray.splice(index, 1);
                    }
                });
                if(tempArray.length === 0)
                    setNoteRequired(false)
            }
        }
        setNoteCheck(tempArray)   

        if(field.name === 'codiceIdentificativo'){
            const tooltip = event ? (event.target ? (event.target.value && event.target.value.length > 0 ? '' : 'Non Presente') : '') : '';
            setTooltipIdentificativo(tooltip);
        }
        if (storSubsectionStructure.multipleValue) {
            addFieldToSubsectionElementChoice(field, event.target.value, id)
        }
        else {
            addFieldToSegnalazioneChoice(field, event.target.value, id)
        }
    }

    function subsectionHandleChangeHourForm(field : Fields, hour : any) {
        const hourFormatted = hour.getHours() + ':' + hour.getMinutes()
        addFieldToSegnalazione(field, hourFormatted)
    }

    function subsectionHandleChangeDateForm(field : Fields, date : any) {
        const dateFormatted = date?.toISOString()
        if (storSubsectionStructure.multipleValue) {
            addFieldToSubsectionElement(field, dateFormatted)
        }
        else {
            addFieldToSegnalazione(field, dateFormatted)
        }
    }

    function copyForReferente(){
        const tmpSubsectionElement : {[key : string] : any} = {}
        Object.assign(tmpSubsectionElement, subsectionElement)
        tmpSubsectionElement['nomeReferente'] = newSegnalazione['identitaSegnalante']['persFisicaSegnalante']['nome'] ;
        tmpSubsectionElement['cognomeReferente'] = newSegnalazione['identitaSegnalante']['persFisicaSegnalante']['cognome'] ;
        tmpSubsectionElement['posizioneReferente'] = newSegnalazione['identitaSegnalante']['persFisicaSegnalante']['posPrezzoSegnalante'] ;
        setSubsectionElement(tmpSubsectionElement)
    }

    function addFieldToSubsectionElement(field : Fields, value : any) {
        const tmpSubsectionElement : {[key : string] : any} = {}
        Object.assign(tmpSubsectionElement, subsectionElement)
        tmpSubsectionElement[field.name] = value
        setSubsectionElement(tmpSubsectionElement)
    }

    function addFieldToSubsectionElementChoice(field : Fields, value : any, id : any) {
        const tmpSubsectionElement : {[key : string] : any} = {}
        Object.assign(tmpSubsectionElement, subsectionElement)
        tmpSubsectionElement[field.name] = value
        tmpSubsectionElement[field.name + 'Id'] = id
        setSubsectionElement(tmpSubsectionElement)
    }

    function addFieldToSegnalazione(field : Fields, value : any) {
        const tmpNewStor : {[key : string] : any} = {}
        Object.assign(tmpNewStor, newSegnalazione)
        tmpNewStor[storSectionName][storSubsectionStructure.id][field.name] = value
        setNewSegnalazione(tmpNewStor)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    function addFieldToSegnalazioneChoice(field : Fields, value : any, id : any) {
        const tmpNewStor : {[key : string] : any} = {}
        Object.assign(tmpNewStor, newSegnalazione)
        tmpNewStor[storSectionName][storSubsectionStructure.id][field.name] = value
        tmpNewStor[storSectionName][storSubsectionStructure.id][field.name + 'Id'] = id
        setNewSegnalazione(tmpNewStor)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    function getDate(field : Fields) {
        if (storSubsectionStructure.multipleValue)
            return subsectionElement[field.name]? new Date(subsectionElement[field.name]) : null
        else if (newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]) {
            return new Date(newSegnalazione[storSectionName][storSubsectionStructure.id][field.name])
        }
        else
            return null
    }

    function getHour(field : Fields) {
        if (storSubsectionStructure.multipleValue)
            return subsectionElement[field.name]? setHourOfDateFromFieldValue(subsectionElement[field.name]) : null
        else if (newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]) {
            return setHourOfDateFromFieldValue(newSegnalazione[storSectionName][storSubsectionStructure.id][field.name])
        }
        else return null
    }

    function setHourOfDateFromFieldValue(value : any) {
        const date = new Date()
        const hour = value.slice(0,2)
        const minute = value.slice(3,5)
        date.setHours(hour)
        date.setMinutes(minute)
        date.setSeconds(0)
        return date
    }

    function addSubsectionElement() {
        if (storSubsectionStructure.multipleValue && requiredFieldOfSubsectionElementIsMissing()) {
            setClickedAddButton(true)
            notificationFunctions.setErrorMessage(CONSTANTS.labelFillAllRequiredFields)
            return
        }
        setClickedAddButton(false)
        const tmpNewStor : {[key : string] : any}= {}
        Object.assign(tmpNewStor, newSegnalazione)
        subsectionElement.id = GENERATEID()// utils.generateId();
        tmpNewStor[storSectionName][storSubsectionStructure.id].push(subsectionElement)
        setSubsectionElements(tmpNewStor[storSectionName][storSubsectionStructure.id])
        setNewSegnalazione(tmpNewStor)
        setSubsectionElement({})
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))
    }

    function requiredFieldOfSubsectionElementIsMissing() {
        let numberOfRequiredFieldMissing = 0
        storSubsectionStructure.fields.map(field => {
            if (field.required && !subsectionElement[field.name])
                numberOfRequiredFieldMissing++
        })
        return numberOfRequiredFieldMissing > 0
    }

    function checkDate(field : any) : boolean{
        let idString = ['dataScadenza','dataInizio','dataFine','dataRegolamento','dataNascita','dataInizioRelazioneProfessionale']
        let checkDate = false
        idString.forEach(id =>{
            if(field === id)
                checkDate=true;
        })
        return checkDate
    }

    function dateConvert(date : string){
        if(date){
            let newDate = new Date(date)
            return newDate.toLocaleDateString()
        }
        else 
            return null
    }

    function deleteSubsectionElement(element : any) {
        const tmpNewStor = {}
        Object.assign(tmpNewStor, newSegnalazione)
        const tmpSubsectionElements : Subsections[] = []
        subsectionElements.map(subsectionElement => {
            if (subsectionElement.id !== element.id)
                tmpSubsectionElements.push(subsectionElement)
        })
        setSubsectionElements(tmpSubsectionElements)
        newSegnalazione[storSectionName][storSubsectionStructure.id] = tmpSubsectionElements
        setNewSegnalazione(newSegnalazione)
        sessionStorage.setItem('newSegnalazione', JSON.stringify(tmpNewStor))

    }

    function checkErrorInField(field : Fields) {
        if (storSubsectionStructure.multipleValue) {
            if (newSegnalazione[storSectionName][storSubsectionStructure.id].length === 0) {
                return (clickedAddButton || errorClickingNextSection) && field.required
            }
            return clickedAddButton && field.required && !subsectionElement[field.name]
        }
        else
            return fieldIsRequiredAndMissing(storSectionName, storSubsectionStructure.id, field)
    }

    function getFormValue(field : Fields) {
        if (storSubsectionStructure.multipleValue) {
            return subsectionElement[field.name] ? subsectionElement[field.name] : ""
        }
        else if (newStorHasFieldMissing(storSectionName, storSubsectionStructure.id, field.name))
            return ""
        else
            return newSegnalazione[storSectionName][storSubsectionStructure.id][field.name]
    }

    function renderForm(field : Fields) {
        switch (field.type) {
            case "text":
                return renderTextForm(field)
            case "textNote":
                return renderTextNoteForm(field)    
            case "number":
                return renderNumberForm(field)
            case "date":
                return renderDateForm(field)
            case "textArea":
                return renderTextAreaForm(field)
            case "hour":
                return renderHourForm(field)
            case "choice":
                return renderChoiceForm(field)
        }
    }

    function changeTooltip(field: Fields): string{
        if(field.name === 'codiceIdentificativo'){
            return tooltipIdentificativo;
        }
        return field.tooltipText;
    }

    const renderTextForm = (field : Fields) => {
        // return <Tooltip placement="bottom" title={field.tooltipText} arrow>
        return <Tooltip placement="bottom" title={changeTooltip(field)} arrow>
            <TextField
                error={checkErrorInField(field)}
                helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                onChange={(event => {subsectionHandleChange(event, field)})}
                fullWidth={true}
                required={field.required}
                value={getFormValue(field)}
                id={field.name}
                label={field.label}
                inputProps={{maxLength:field.max}}
            />
        </Tooltip>
    }

    const renderTextNoteForm = (field : Fields) => {
        // return <Tooltip placement="bottom" title={field.tooltipText} arrow>
        return <Tooltip placement="bottom" title={changeTooltip(field)} arrow>
            <TextField
                error={checkErrorInField(field)}
                helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                onChange={(event => {subsectionHandleChange(event, field)})}
                fullWidth={true}
                required = {noteRequired}
                value={getFormValue(field)}
                id={field.name}
                label={field.label}
                inputProps={{maxLength:field.max}}
            />
        </Tooltip>
    }

    const renderNumberForm = (field : Fields) => {
        return <TextField
            type = "number"
            error={checkErrorInField(field)}
            helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
            onChange={(event => {subsectionHandleChange(event, field)})}
            required={field.required}
            fullWidth={true}
            value={getFormValue(field)}
            id={field.name}
            label={field.label}
            // inputProps={{ inputMode: 'numeric',  pattern: '[0-9]*' }}
        />
    }

    const renderTextAreaForm = (field : Fields) => {
        return <TextField
                rows={3}
                multiline
                error={checkErrorInField(field)}
                helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                onChange={(event => {subsectionHandleChange(event, field)})}
                required={field.required}
                fullWidth={true}
                defaultValue={getFormValue(field)}
                id={field.name}
                label={field.label}
                inputProps={{maxLength:field.max}}
            />
    }

    const renderDateForm = (field : Fields) => {
        return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
            <MobileDatePicker
                componentsProps={{
                    actionBar: {
                        actions: ['clear','accept']
                    }
                }}
                label={field.label}
                value={getDate(field)}
                maxDate={field.name === 'dataNascita'? maxDate : new Date('2099-12-31')}
                onChange={(date) => {
                    subsectionHandleChangeDateForm(field, date);
                }}
                renderInput={(params) => <TextField {...params}
                    error={checkErrorInField(field)}
                    helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                    required={field.required}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="end">
                                        <EventIcon/>
                                    </InputAdornment>,
                    }}/>
                }
            />
        </LocalizationProvider>
    }



    const renderHourForm = (field : Fields) => {
        return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'it'}>
            <MobileTimePicker
                label={field.label}
                value={getHour(field)}
                onChange={(hour : any) => {
                    subsectionHandleChangeHourForm(field, hour);
                }}
                renderInput={(params : any) => <TextField {...params}
                            error={checkErrorInField(field)}
                            helperText={checkErrorInField(field) && errorClickingNextSection ? 'Il campo è obbligatorio' : ""}
                            required={field.required}
                            fullWidth
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <AccessTimeIcon/>
                                </InputAdornment>,
                            }}/>
                }
            />
        </LocalizationProvider>
    }

    const renderChoiceForm = (field : Fields) => {
        return <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{field.required? field.label + " *" : field.label}</InputLabel>
                <Select
                    value={getFormValue(field)}
                    label={field.required? field.label + "*" : field.label}
                    required = {field.required}
                    error={checkErrorInField(field)}
                    onChange={(event => {subsectionHandleChangeChoice(event, field)})}>
                    <MenuItem key="" value="">{'-Seleziona-'}</MenuItem>
                    {segnalazioneChoiceLists[field?.choiceListName || '']?.map((choice : any) => {
                        return <MenuItem key={choice.id} value={choice.name}>
                            {choice.name}
                        </MenuItem>
                    })}
                </Select>
        </FormControl>
    }

    return (
        <>
            {
                storSubsectionStructure.id === 'descrizioneOrdine' ?
                    <FormControlLabel className="mt-4" control={<Switch defaultChecked={false}/>}
                                      label="Inserimento multiplo (Utilizzare questa opzione nel caso di 3 o più Ordini/Operazioni)" />
                    :
                    <></>
            }
            {
                storSubsectionStructure.id === 'referenteRichiestaMaggioriInfo' ?
                    <div className="mt-5">
                        <CustomButtonSecondary
                        onClick={() => {copyForReferente()}}
                        className="col-auto"
                        variant="contained">Recupera Dati</CustomButtonSecondary>
                    </div>
                    :
                    <></>
            }
            <div className="mt-4 mb-4 row">
                {storSubsectionStructure.fields.map(field => {
                    return <div key={field.name} className={"col-md-" + field.numColMd + " mt-3 col-sm-12"}>
                        {renderForm(field)}
                    </div>})
                }
            </div>
            {storSubsectionStructure.multipleValue ?
                <div className="col-12 text-center">
                    <CustomButtonSecondary onClick={addSubsectionElement}>Aggiungi</CustomButtonSecondary>
                </div>
                :
                <></>
            }
            {subsectionElements && subsectionElements.length > 0 ? subsectionElements.map(subsectionElement => {
                return <div key={subsectionElement.id}>
                    <div className="row mt-3">
                        <div className="card-body row">
                            <div className="row">
                                <div className="mt-3 font-medium-custom text-bold col-6 mb-3">
                                    <span className="margin-right-5">{storSubsectionStructure.labelForAddedValues}</span>
                                    <span className="color-delete pointer">
                                        <DeleteOutlineOutlinedIcon onClick={() => deleteSubsectionElement(subsectionElement)}/>
                                    </span>
                                </div>
                            </div>
                            {storSubsectionStructure.fields.map(field => {
                                return <div key={field.name} className="row mt-3 col-md-3">
                                    {checkDate(field.name) ?
                                        <span><strong className="margin-right-5">{field.label}:</strong> {dateConvert(subsectionElement[field.name])}</span>
                                        :
                                        <span><strong className="margin-right-5">{field.label}:</strong> {subsectionElement[field.name]}</span>
                                    }
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            }) : <></>}
        </>
    )
}

export default SegnalazioneCreateSubsection;
